export default __webpack_public_path__ + "static/media/AdhesiveScreeds.65e7bf29.png";